import { PULL_REFRESH_RELEASE_THRESHOLD } from '../../hooks/useScrollPullToRefresh'
import { TimelinePullIndicator } from '../create/TimelineRefreshSurfaces'

type Props = {
  angular: boolean
  /** 读屏 / aria-label；视觉以主题下拉宝石动画为主 */
  label?: string
  className?: string
}

/**
 * 首屏异步加载：复用 {@link TimelinePullIndicator} 的「刷新中」态（与图库、生图时间线一致），
 * 不单独写进度条或骨架顶栏。
 */
export function AsyncPullLoadingIndicator({
  angular,
  label = '加载中',
  className = '',
}: Props) {
  return (
    <div
      className={['flex w-full flex-col items-center py-6 sm:py-10', className].filter(Boolean).join(' ')}
      role="status"
      aria-busy="true"
      aria-label={label}
    >
      <div className="select-none w-full" aria-live="polite">
        <TimelinePullIndicator
          pullPx={PULL_REFRESH_RELEASE_THRESHOLD}
          releaseThreshold={PULL_REFRESH_RELEASE_THRESHOLD}
          angular={angular}
          commitFly={false}
          refreshing
        />
      </div>
      <p className="sr-only">{label}</p>
    </div>
  )
}
